import { Dialog } from '@cimplico/components';
import { Invitation } from '../../types/invitation';
import { useResendInvitations } from './use-resend-invitations';
import plural from '../../utilities/plural';

type InvitationResendConfirmDialogProps = {
    invitations: Invitation[];
    isOpen: boolean;
    onClose: () => void;
    onResend: () => void;
};

function InvitationResendConfirmDialog({ invitations, isOpen, onClose, onResend }: InvitationResendConfirmDialogProps): JSX.Element {
    const { isLoading, resendInvitations } = useResendInvitations();

    async function resendQuery(): Promise<void> {
        try {
            await resendInvitations(invitations);
            onResend();
        } catch {
            onClose();
        }
    }

    return (
        <Dialog
            description={`Do you want to resend ${invitations.length} ${plural(
                invitations.length,
                'invitation',
                'invitations'
            )}? Expiry and status for the ${plural(invitations.length, 'invitation', 'invitations')} will be reset.`}
            type="info"
            title="Resend Invitations"
            primaryAction="Resend"
            secondaryAction="Cancel"
            onClose={onClose}
            onPrimaryActionClick={resendQuery}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            isLoading={isLoading}
        />
    );
}

export default InvitationResendConfirmDialog;
